"use client"

import { datadogRum } from "@datadog/browser-rum"

import { TreatmentConfig } from "@lib/clients/nelo-api-client"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"
export const mapTreatmentConfigToPayload = <T>(featureName: string, treatmentConfig: TreatmentConfig<T>) => {
  if (!treatmentConfig) return null
  return {
    feature_name: featureName,
    tracking_key: treatmentConfig.trackingKey,
    treatment_name: treatmentConfig.treatment,
  }
}

export const sendExperimentInclusionEvent = <T>(featureName: string, treatmentConfig: TreatmentConfig<T>): void => {
  const payload = mapTreatmentConfigToPayload(featureName, treatmentConfig)
  if (!payload) return

  datadogRum.addFeatureFlagEvaluation(payload.feature_name, payload.treatment_name)
  datadogRum.setUserProperty(`experiment.${payload.feature_name}`, payload.treatment_name)

  sendGoogleAnalyticsEvent("XP_INCLUSION", payload)
}
